<template>
  <nav class="navbar navbar-expand-lg drop-shadow">
    <span class="downArrow"></span>
    <a class="navbar-brand" href="#">
      <img src="https://apps.pharmerit.com/qtwist/imgs/logo.svg" width="210" height="43" alt>
    </a>
    <div class="collapse navbar-collapse" id="navbarText">
      <span class="navbar-text">HEOR Dashboard & UI Services</span>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Nav"
}
</script>

<style lang="scss">
@import "../scss/bootstrap-custom.scss";
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
</style>


// WEBPACK FOOTER //
// src/components/Nav.vue